import { PASSWORD_RULES, checkPassword, passwordStrength } from '../utils/passwordPolicy';
import '../styles/PasswordStrengthMeter.css';

/**
 * C2: the four password rules with a met/not-met glyph and a four-segment
 * strength bar. Purely presentational; the parent form does the validation.
 */
export const PasswordStrengthMeter = ({ password }) => {
    const value = password || '';
    const { failures } = checkPassword(value);
    const strength = passwordStrength(value);

    return (
        <div className="pw-meter">
            <div
                role="progressbar"
                aria-label="Password strength"
                aria-valuemin="0"
                aria-valuemax="4"
                aria-valuenow={strength}
                className="pw-meter-bar"
                data-strength={strength}
            >
                {[1, 2, 3, 4].map((n) => (
                    <span key={n} className="pw-meter-segment" />
                ))}
            </div>
            <ul className="pw-meter-rules">
                {PASSWORD_RULES.map((rule) => {
                    const met = !failures.includes(rule.id);
                    return (
                        <li
                            key={rule.id}
                            className={met ? 'pw-meter-rule pw-meter-rule--met' : 'pw-meter-rule'}
                            aria-label={`${rule.label}: ${met ? 'met' : 'not met'}`}
                        >
                            <span className="pw-meter-glyph" aria-hidden="true">{met ? '✓' : '•'}</span>
                            <span className="pw-meter-label">{rule.label}</span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
